<template>
  <router-view 
    v-if="!isLoading" 
    v-on:changeLoadingOverlay="changeLoadingOverlay($event)"
  ></router-view>
  
  <v-overlay v-else>
    <v-progress-circular
      indeterminate
      size="64"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '@/services/api.service';

export default {
  name: 'App',
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...mapGetters(['isLoggedIn', 'token']),
  },
  methods: {
    changeLoadingOverlay(value) {
      this.isLoading = value;
    }
  },
  created () {
    if (this.isLoggedIn) {
      Api.defaults.headers.common['Authorization'] = `Bearer ${this.token}`
    }
  }
};
</script>

<style lang="scss">
@import 'styles/_global.scss';
</style>
